import { Link } from 'react-router-dom';

/**
 * Shared read-only career narrative (company header + open positions).
 * @param {{ data: object, readOnly?: boolean }} props — same shape as GET /api/career/public
 */
export default function CareerPublicContent({ data, readOnly = false }) {
  if (!data) return null;

  return (
    <>
      <header className="bg-white border-b">
        <div className="max-w-5xl mx-auto px-6 py-8 text-center">
          {data.company_logo && (
            <img
              src={data.company_logo}
              alt={data.company_name || 'Company'}
              className="h-14 max-w-full object-contain mx-auto mb-4"
            />
          )}
          <h1 className="text-3xl font-bold text-gray-900">{data.company_name || 'Careers'}</h1>
          {data.company_info && (
            <p className="text-gray-600 mt-3 max-w-2xl mx-auto whitespace-pre-wrap">{data.company_info}</p>
          )}
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 py-10">
        <h2 className="text-2xl font-bold text-gray-900 mb-6">Open Positions</h2>
        {data.departments?.length ? (
          <div className="space-y-8">
            {data.departments.map(dept => (
              <div key={dept.department}>
                <h3 className="text-lg font-semibold text-gray-800 mb-3">{dept.department}</h3>
                <div className="grid gap-3">
                  {dept.positions.map(pos => (
                    <div
                      key={pos.id}
                      className="bg-white border rounded-lg p-4 flex flex-wrap items-center justify-between gap-3 hover:shadow-sm transition-shadow"
                    >
                      <div className="min-w-0 flex-1">
                        <h4 className="font-medium text-gray-900">{pos.title}</h4>
                        <p className="text-sm text-gray-500">{dept.department}</p>
                      </div>
                      {readOnly ? (
                        <span className="text-xs text-gray-400">Public listing</span>
                      ) : (
                        <Link
                          to={`/apply?department=${encodeURIComponent(dept.department)}&position=${encodeURIComponent(pos.title)}`}
                          className="inline-flex items-center justify-center gap-2 w-full sm:w-auto min-h-[44px] px-5 rounded-xl bg-brand-600 text-white text-sm font-semibold shadow-sm hover:bg-brand-700 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-300 focus-visible:ring-offset-2"
                        >
                          Apply Now &rarr;
                        </Link>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-gray-500">No open positions at this time. Check back later.</p>
        )}
      </main>

      <footer className="border-t bg-white py-6 text-center text-sm text-gray-400">
        Powered by Genesis Creations Talent Hub
      </footer>
    </>
  );
}
